/**
 * The colours a chart gives its data marks, in order: a line per series, a single series' bars, dots or sparkline.
 * Each is a theme token (index.css, `--color-chart-N`) that stands at least 3:1 on the chart surfaces in both themes.
 * Never the brand colour: a tenant sets that, and Graphite's slate all but vanished on the dark surface (2026-10-17).
 * Status colours (success, warning, danger) stay for meaning: pass and fail, thresholds, limits.
 */
export const SERIES_PALETTE = [
  "rgb(var(--color-chart-1))",
  "rgb(var(--color-chart-2))",
  "rgb(var(--color-chart-3))",
  "rgb(var(--color-chart-4))",
  "rgb(var(--color-chart-5))",
  "rgb(var(--color-chart-6))",
] as const;

/** The colour of the series at an index: its own when it has one, else the palette's, in order. */
export function seriesColor(idx: number, override?: string): string {
  if (override) return override;
  return SERIES_PALETTE[idx % SERIES_PALETTE.length];
}
